import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { AppSocketContext } from "@/routes";
import { selectMemberInfos } from "@/store/reducers/member/member.selector";
import { TMemberInfos } from "@/features/profile/types";
import "./ImpersonationBanner.styles.scss";

/**
 * Bandeau permanent affiché quand la session courante a été ouverte par un
 * staff depuis le back-office ("se connecter en tant que ce membre").
 * Rappelle le contexte et permet de mettre fin à la session en un clic.
 */
const ImpersonationBanner: React.FC = () => {
  const { logout } = useContext(AppSocketContext);
  const memberInfos = useSelector(selectMemberInfos) as TMemberInfos;

  if (!memberInfos?.impersonatedBy) {
    return null;
  }

  const handleLeave = async () => {
    // On attend la fin du logout (requête serveur + purge locale) avant de
    // fermer l'onglet : sinon le navigateur peut annuler la requête en vol
    // et la session d'impersonation ne serait jamais révoquée côté serveur.
    await logout();
    // window.close() n'a d'effet que sur un onglet ouvert par script (ce qui
    // est le cas ici, via le back-office) ; sinon, le logout() ci-dessus a
    // déjà renvoyé l'utilisateur sur la page de connexion.
    window.close();
  };

  return (
    <div className="impersonation-banner">
      <span>
        Session d'administration — vous naviguez en tant que{" "}
        <strong>{memberInfos.username}</strong>
      </span>
      <button type="button" onClick={handleLeave}>
        Quitter
      </button>
    </div>
  );
};

export default ImpersonationBanner;
